export default {
  install() {
    if (window.html2pdf) {
      // 覆盖掉现有的
      window.html2pdf = () => Promise.reject('html2pdf disabled');
    }

    Object.defineProperty(window, 'html2pdf', {
      configurable: false,
      get() {
        return () => Promise.reject('html2pdf disabled');
      },
      set() {
        console.warn('⚠️ 阻止覆盖 html2pdf');
      },
    });
  },
};
